export const multipleDepositConfig = {
    name: "Payment Multiple Deposit Config",
    create:"Create",
    priority:"Priority",
    action:"Action",
    paymentName:"Payment Name",
    cancel:"Cancel",
    delete:'Delete',
    errorHighPriority:'Highest Priority',
    errorlowPriority:'Lowest Priority',
    save:'Save'
  };
  